import React from 'react';
import PropTypes from 'prop-types';

import './Checkbox.scss';


export const Checkbox = ({
  id, value, name, onChange, labelDisplay, labelPosition, disabled, required,
}) => {
  let flexClass = '';
  switch (labelPosition) {
    case 'top':
      flexClass = 'flex-column justify-content-center';
      break;
    case 'right':
      flexClass = 'flex-row-reverse align-items-start justify-content-end';
      break;
    case 'bottom':
      flexClass = 'flex-column-reverse';
      break;
    case 'left':
      flexClass = 'flex-row';
      break;
    default:
  }
  return (
    <div className="AD_checkbox">
      <label
        htmlFor={id}
        className={`d-flex m-0 align-items-center ${flexClass} ${disabled ? 'disabled' : ''} ${required ? 'required' : ''}`}
      >
        <span className="pl-3">{labelDisplay}</span>
        <input type="checkbox" disabled={disabled} id={id} name={name} value={value} onChange={onChange} aria-checked="mixed" />
        <span className={`checkBox ${disabled ? 'disabled' : ''}`} />
      </label>
    </div>
  );
};
Checkbox.defaultProps = {
  labelPosition: 'left',
  value: '',
  name: '',
  onChange: () => {},
  labelDisplay: '',
  disabled: false,
  required: false,
};
Checkbox.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  labelDisplay: PropTypes.string,
  labelPosition: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  disabled: PropTypes.bool,
  required: PropTypes.bool,
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/Checkbox/Checkbox.jsx